var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      style: { "z-index": _vm.zIndex },
      attrs: {
        value: _vm.open,
        "overlay-color": "#000",
        "overlay-opacity": "0.66",
        persistent: _vm.persistent,
        "max-width": "500"
      },
      on: { input: _vm.update }
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-card" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "d-flex justify-space-between ",
              class: !_vm.persistent ? "dialog-title-close" : null
            },
            [
              _c("span", [_vm._v(" " + _vm._s(_vm.l_header) + " ")]),
              !_vm.persistent
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.update(false)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "white100" },
            [
              _c("text-group", {
                attrs: {
                  invert: "",
                  large: "",
                  utext: _vm.l_text,
                  btext: _vm.l_title,
                  btextBold: false
                }
              })
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              !_vm.isMobile ? _c("v-spacer") : _vm._e(),
              !_vm.hideCancel
                ? _c(
                    "v-btn",
                    {
                      class: ["btn-secondary"],
                      on: {
                        click: function($event) {
                          return _vm.cancelAction()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.yesNo ? "Nie" : "Zrušiť") + " ")]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  staticClass: "btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.doAction()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.yesNo ? "Áno" : "Ok") + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }